import React from 'react';
import CommonField from "./CommonField.jsx";
import NumberInput from '../../../../common/NumberInput.jsx';
import get from 'lodash/get';

function NumberSetting(props) {
  const { attr, prefix = '', label, setAttribute, selectedObject, defaultValue = undefined } = props;
  const fullAttr = [prefix, attr].filter(Boolean).join('.');
  return (
    <CommonField label={label} {...props} attr={fullAttr}>
      <NumberInput
        type='number'
        value={get(selectedObject, fullAttr) ?? defaultValue}
        afterChange={(value) => setAttribute(fullAttr, value)}
      />
    </CommonField>
  )
}

export default NumberSetting;